import { Link, Text } from 'native-base';
import React, { memo } from 'react';
const VIEW_ESCROW_LINKS = 'View your escrow analysis statement';
const StatementsLink = _ref => {
  let {
    onStatementsLinkClick
  } = _ref;
  return /*#__PURE__*/React.createElement(Text, {
    mt: "2",
    alignSelf: 'center',
    accessibilityLabel: VIEW_ESCROW_LINKS,
    accessibilityRole: "link"
  }, /*#__PURE__*/React.createElement(Link, {
    onPress: onStatementsLinkClick,
    _text: {
      fontSize: {
        base: 'md',
        md: 'lg',
        lg: 'lg'
      }
    },
    accessibilityLabel: VIEW_ESCROW_LINKS,
    accessibilityRole: "link"
  }, VIEW_ESCROW_LINKS));
};
export default /*#__PURE__*/memo(StatementsLink);
//# sourceMappingURL=index.js.map